<template>
  <div class="wrap">

    <Head />
    <div class="part1">
      <p class="tit">区块链疫苗溯源平台</p>
      <p class="txt">基于区块链与物联网技术追踪记录疫苗的流转链条，将疫苗的管理、运输与接种信息上链存证，打造易监管、高可信的疫苗溯源生态体系</p>
      <div class="img">
        <img
          src="../../../assets/images/mobile/solution/part1-2.png"
          alt=""
        >
      </div>
    </div>

    <div class="part2">
      <p class="tit">方案介绍</p>
      <div
        class="show"
        id="show"
        style="height:auto"
      >
        <div class="line">
          基于恒为链的疫苗溯源平台，融合了区块链与物联网技术。通过RFID电子标签、温湿度传感器等硬件设备，采集疫苗在运输过程中的存储情况与地理位置信息，实现对疫苗存储数据以及运输轨迹的自动化采集与全线追踪，有效保障疫苗质量与安全。同时，通过区块链技术，实现疫苗数据的上链存证，记录疫苗在途运输与使用情况，保证疫苗运输数据上链的真实性和可追溯性，实现疫苗生产、运输、接种等环节数据的公开透明。
        </div>
      </div>
      <div
        class="btn"
        v-show="show"
      >
        <div class="btn">
          <p
            @click="getChange('more')"
            v-show="more"
          >
            <span>查看更多</span>
            <i class="iconfont  iconxia"></i>
          </p>
          <p
            @click="getChange('less')"
            v-show="!more"
          >
            <span>收起</span>
            <i class="iconfont  iconshang"></i>
          </p>
        </div>
      </div>
      <div class="img">
        <img
          src="../../../assets/images/mobile/solution/vaccine/part2.png"
          alt=""
        >
      </div>

    </div>

    <div class="part3">
      <p class="tit">方案价值</p>
      <div class="center">
        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/vaccine/part3-1.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">接种者受益</p>
            <p class="text">
              基于区块链技术建立完善的疫苗信息数据存储和管理机制，确保数据完整、有效、不可篡改和可追溯，为接种者提供疫苗从运输到接种全流程信息追溯
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/vaccine/part3-2.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">疫苗存储单位受益</p>
            <p class="text">
              通过RFID电子标签技术，实现对疫苗出入库数据的自动化采集，提高疫苗的冷链运输效率
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/vaccine/part3-3.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">监管机构受益</p>
            <p class="text">
              资产转账速度快，仅需3-对每支疫苗的流通有据可查，杜绝造假现象，解决监管脱节的问题
            </p>
          </div>
        </div>
      </div>

    </div>

    <div class="part4">
      <p class="tit">产品核心功能</p>
      <div class="card">
        <div class="content">
          <p class="title">疫苗存证溯源平台</p>
          <div class="line">
            疫苗存证溯源平台旨在建立信息化追溯平台。将每一支疫苗数字凭证化，实现疫苗从生产到运输再到接种各个环节精细化监管。接种人通过疫苗溯源码获取接种疫苗的全流程信息，真正做到疫苗数据的公开透明和真实可溯。同时，监管机构通过平台对疫苗的流通全流程监管，对问题环节及时有效的定责追责。
          </div>
        </div>
      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/mobile/Head.vue";
import Foot from "../../../components/mobile/Foot.vue";
export default {
  data() {
    return {
      show: false,
      more: true,
    };
  },
  components: {
    Head,
    Foot,
  },
  created() {},
  mounted() {
    this.getShow();
  },
  methods: {
    //判断是否显示加载更多
    getShow() {
      let h = document.getElementById("show").offsetHeight;
      let w = document.body.clientWidth;
      if (h > w * 0.31) {
        this.show = true;
        document.getElementById("show").style.height = "31vw";
      } else {
        this.show = false;
      }
    },
    getChange(type) {
      if (type == "more") {
        this.more = false;
        document.getElementById("show").style.height = "auto";
      } else {
        this.more = true;
        document.getElementById("show").style.height = "31vw";
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);
  background: linear-gradient(-30deg, #1460B6, #2B9CE4);
  position: relative;
  part1();
  padding-top: vw(57);

  .tit {
    margin-bottom: vw(22);
    hTit();
  }

  .txt {
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: #fff;
    padding: 0 vw(80);
  }

  .img {
    width: 100%;
    position: absolute;
    bottom: vw(20);
    text-align: center;

    img {
      width: vw(347);
      height: vw(360);
    }
  }
}

.part2 {
  part();
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .show {
    overflow: hidden;
    transition: all 0.3s ease;

    .line {
      font-size: vw(28);
      color: #666666;
      line-height: vw(48);
      margin-bottom: vw(30);
      padding: 0 vw(30);
    }
  }

  .btn {
    margin-top: vw(40);

    p {
      width: vw(240);
      height: vw(80);
      background: #fff;
      border-radius: vw(40);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      margin: 0 auto;

      span {
        display: inline-block;
        height: vw(80);
        color: #2A93FF;
        font-size: vw(30);
        line-height: vw(80);
      }

      i {
        margin-left: vw(5);
        display: inline-block;
        height: vw(80);
        font-size: vw(24);
        color: #2A93FF;
        line-height: vw(80);
      }
    }
  }

  .img {
    margin-top: vw(60);
    text-align: center;

    img {
      width: vw(690);
      height: auto;
    }
  }
}

.part3 {
  part();
  background: rgba(249, 249, 249, 1);

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .center {
    width: 100%;

    .card {
      display: flex;
      width: vw(690);
      height: vw(241);
      margin: 0 auto vw(30);
      padding: vw(44) vw(45) 0 vw(40);
      background: #fff;
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .left {
        width: vw(179);
        margin-right: vw(37);
        padding-top: vw(14);

        img {
          width: 100%;
          height: auto;
        }
      }

      .right {
        flex: 1;

        .title {
          font-size: vw(32);
          line-height: vw(32);
          margin: vw(4) 0 vw(10);
          color: #444444;
        }

        .text {
          font-size: vw(24);
          color: #888;
          line-height: vw(36);
          showline(3)
        }
      }
    }
  }
}

.part4 {
  part();
  background: #fff;
  padding: vw(80) 0 vw(40);

  .tit {
    tit3();
    margin-bottom: vw(80);
  }

  .card {
    width: vw(690);
    padding: vw(20);
    margin: 0 auto vw(40);
    background: #fff;
    box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

    .img {
      text-align: center;

      img {
        width: vw(650);
        height: auto;
      }
    }

    .content {
      margin-top: vw(60);

      .title {
        font-size: vw(32);
        font-weight: 500;
        color: rgba(68, 68, 68, 1);
        line-height: vw(32);
        margin-bottom: vw(30);
        text-align: center;
      }

      .line {
        font-size: vw(24);
        color: #888888;
        line-height: vw(36);
        margin-bottom: vw(40);
      }
    }
  }
}
</style>
